import { TableBody, TableCell } from '@material-ui/core'
import React, { useEffect } from 'react'
import { itemsPerPage } from '../../../shared/data'
import CustomPagination from '../../CustomPagination'
import Layout from '../../Layout'
import Loader from '../../Loader'
import CustomTable from '../../Table/CustomTable'
import CustomTableHeading from '../../Table/CustomTableHeading'
import CustomTableRow from '../../Table/CustomTableRow'
import styles from '../reports.module.css'
import { NoDataFound } from '../../NoDataFound'
import { useLead } from '../../../hooks/Features/useLeads'
import { SortIcon, FilterIcon } from '../../CustomComponents/CustomFilterIcon'

export default function ProductCategoryLeadReport() {
  const { loading, getProductCategoryLeadReport, lead } = useLead()
  const [page, setPage] = React.useState(1)
  const [date, setDate] = React.useState(new Date())

  useEffect(() => {
    setPage(1)
    getProductCategoryLeadReport({ date: date })
  }, [date])

  const noOfPages = Math.ceil(lead && lead.length / itemsPerPage)
  const handleChange = (event, value) => {
    setPage(value)
  }

  const heading = [
    { label: 'Category', key: 'category' },
    { label: 'Yesterday Lead Number', key: 'yln' },
    { label: 'Yesterday Lead Value', key: 'ylv' },
    { label: 'MTD Lead Number', key: 'mln' },
    { label: 'MTD Lead Value', key: 'mlv' },
    { label: 'QTD Lead Number', key: 'qln' },
    { label: 'QTD Lead Value', key: 'qlv' },
  ]

  let tempLead = []
  lead &&
    lead.forEach((item) =>
      tempLead.push({
        category: item.name,
        yln: item.yesterday.leadNumbers,
        ylv: item.yesterday.leadValue.toFixed(2),
        mln: item.MTD.leadNumbers,
        mlv: item.MTD.leadValue.toFixed(2),
        qln: item.QTD.leadNumbers,
        qlv: item.QTD.leadValue.toFixed(2),
      })
    )

  return (
    <Layout heading="Product Category Lead Report"
      none
      selectedDate={date}
      setSelectedDate={setDate}
      headers={heading}
      data={tempLead ? tempLead : []}
      tempHeaderData={[]}
      filename='product_category_lead_report'
    >
      <CustomTable padding className={styles.table} tableId="reportTable">
        <CustomTableHeading
          columnSpan={{ "YESTERDAY": 2, "MTD": 2, "QTD": 2 }}
          heading={['CATEGORY', 'YESTERDAY', 'MTD', 'QTD']} />
        <CustomTableRow className={styles.subHead}>
          <TableCell></TableCell>
          {['yesterday', 'MTD', 'QTD'].map((val) => {
            return (
              <React.Fragment>
                <TableCell style={{ borderLeft: '1px solid black' }}>Lead Number</TableCell>
                <TableCell>Lead Value</TableCell>
              </React.Fragment>
            )
          })}
          {/* </TableCell> */}
        </CustomTableRow>
        <TableBody>
          {!loading &&
            lead.length > 0 &&
            lead.slice((page - 1) * itemsPerPage, page * itemsPerPage).map((item, index) => {
              return (
                <CustomTableRow style={{ backgroundColor: 'white' }}>
                  <TableCell>{item.name}</TableCell>
                  {['yesterday', 'MTD', 'QTD'].map((val) => {
                    return (
                      <React.Fragment>
                        <TableCell style={{ borderLeft: '1px solid black' }}>{item[val].leadNumbers}</TableCell>
                        <TableCell>{parseFloat(item[val].leadValue).toFixed(2)}</TableCell>
                      </React.Fragment>
                    )
                  })}
                </CustomTableRow>
              )
            })}
        </TableBody>
      </CustomTable>
      {loading && <Loader />}
      {!loading && lead.length > 0 && (
        <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />
      )}

      {/* <button onClick={() => exportTableToExcel("newExcel")}>click to download</button> */}

      {!loading && lead.length === 0 && <NoDataFound />}
    </Layout>
  )
}
